export const validateName = (
  name: string,
  t?: (key: string) => string
): string | null => {
  if (!name || name.trim().length === 0) return null;

  const trimmedName = name.trim();
  const errorMessage = t
    ? t("register.validation.firstNameInvalid")
    : "Please enter a valid name, using only letters.";

  // Check maximum length (50 characters)
  if (trimmedName.length > 50) {
    return errorMessage;
  }

  // Check if name contains only letters, hyphens, and apostrophes
  if (!/^[a-zA-ZÀ-ÿ\s\-']+$/.test(trimmedName)) {
    return errorMessage;
  }

  return null;
};
